import { Reveal } from "@/components/Reveal";

const experiences = [
  {
    number: "01",
    title: "Intimate Candlelit Dinners",
    description:
      "Your closest people around one long table — favourite dishes, familiar music, and an evening where grief and joy arrive as equals.",
    image: "/images/dinner.jpg",
    alt: "A candlelit table set for an intimate dinner",
  },
  {
    number: "02",
    title: "Weekend Retreats with Chosen Family",
    description:
      "A few days unplugged and fully present with the people you chose — a little sacred, a lot unfiltered.",
    image: "/images/retreat.jpg",
    alt: "A quiet gathering of chosen family on retreat",
  },
  {
    number: "03",
    title: "Grand Masquerade Farewells",
    description:
      "Wine, music and dancing for everyone you have ever known. Nothing off-limits; everything exactly as you imagined it.",
    image: "/images/masquerade.jpg",
    alt: "An elegant masked celebration in candlelight",
  },
  {
    number: "04",
    title: "Personal Spiritual Rituals",
    description:
      "A ceremony shaped by your own tradition and meaning — never someone else's template, never for show.",
    image: "/images/ritual.jpg",
    alt: "A symbolic ritual by the water at dusk",
  },
];

export const Experiences = () => {
  return (
    <section
      id="experiences"
      className="py-32 md:py-44 overflow-hidden"
      data-testid="experiences-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-[#7D1B56] mb-6">
            The Experiences
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight text-[#02515A] max-w-2xl">
            Every goodbye looks different.
            <br />
            <span className="italic">Death comes with no template.</span>
          </h2>
        </Reveal>

        <div className="mt-24 md:mt-32 space-y-28 md:space-y-40">
          {experiences.map((exp, index) => {
            const reversed = index % 2 === 1;
            return (
              <div
                key={exp.number}
                className="grid md:grid-cols-12 gap-10 md:gap-16 items-center"
                data-testid={`experience-card-${index + 1}`}
              >
                <Reveal
                  className={`md:col-span-7 ${reversed ? "md:order-2 md:translate-y-10" : "md:-translate-y-6"}`}
                >
                  <div className="border border-[#7D1B56]/40 p-2 md:p-3">
                    <div className="overflow-hidden">
                    <img
                      src={exp.image}
                      alt={exp.alt}
                      loading="lazy"
                      className="w-full h-[320px] md:h-[460px] object-cover transition-transform duration-1000 ease-out hover:scale-105"
                    />
                    </div>
                  </div>
                </Reveal>
                <Reveal
                  delay={0.15}
                  className={`md:col-span-5 ${reversed ? "md:order-1" : ""} ${reversed ? "md:pr-8" : "md:pl-8"}`}
                >
                  <h3 className="font-serif-display font-light text-3xl md:text-4xl leading-snug text-[#02515A]">
                    {exp.title}
                  </h3>
                  <p className="mt-6 text-base font-light leading-loose text-[#3F6B72]">
                    {exp.description}
                  </p>
                </Reveal>
              </div>
            );
          })}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-28 md:mt-36 text-center font-serif-display italic font-light text-2xl md:text-3xl text-[#7D1B56] max-w-2xl mx-auto leading-relaxed">
            Or something entirely your own. There is no blueprint for this — no
            right way to do dying.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
